// removed by extract-text-webpack-plugin
module.exports = {"faqs__filter":"faqs__filter","faqs__filter-item":"faqs__filter-item","faqs__filter-link":"faqs__filter-link","active":"active","faqs__list-item":"faqs__list-item"};


//////////////////
// WEBPACK FOOTER
// ./resources/views/library/patterns/faqs/faqs.scss
// module id = 65
// module chunks = 2